// Stable browser-scoped founder identity. No login for MVP.
const KEY = "velo21_founder_id";

export function getFounderId() {
  try {
    let id = localStorage.getItem(KEY);
    if (!id) {
      id = (crypto?.randomUUID?.() || `f_${Date.now()}_${Math.random().toString(36).slice(2)}`);
      localStorage.setItem(KEY, id);
    }
    return id;
  } catch {
    // fallback for privacy-mode browsers
    return `f_${Date.now()}_${Math.random().toString(36).slice(2)}`;
  }
}
